import { API_URL } from '../api';

export interface DealProductRow {
  productId: string;
  originalPrice: number;
  dealPrice: number;
  discountPercent: number;
  stock?: number | null;
  maxQuantityPerUser?: number | null;
}

export interface DealSectionGroup {
  brandId: string;
  categoryId: string;
  subCategory: string;
  brandName?: string;
  categoryName?: string;
  groupKey: string;
}

export interface DealSection {
  _id?: string;
  title: string;
  order: number;
  layout: 'slider' | 'grid';
  defaultDiscountPercent: number;
  products: DealProductRow[];
  groups: DealSectionGroup[];
}

export interface PublicDeal {
  _id: string;
  title: string;
  slug: string;
  subtitle?: string;
  description?: string;
  type: string;
  bannerImage?: string;
  bannerMobileImage?: string;
  displayLabel?: string;
  showTimer?: boolean;
  showBadge?: boolean;
  badgeText?: string;
  startDate: string;
  endDate: string;
  products?: Array<{
    productId: unknown;
    originalPrice: number;
    dealPrice: number;
    discountPercent: number;
    product?: {
      _id: string;
      name: string;
      slug: string;
      images?: unknown[];
      price?: unknown;
      mrp?: number;
    };
  }>;
  sections?: Array<{
    _id?: string;
    title: string;
    order: number;
    layout: string;
    defaultDiscountPercent: number;
    groups: DealSectionGroup[];
    products: Array<{
      originalPrice: number;
      dealPrice: number;
      discountPercent: number;
      product?: {
        _id: string;
        name: string;
        slug: string;
        images?: unknown[];
        price?: unknown;
        mrp?: number;
      };
    }>;
  }>;
}

export async function fetchDealsPageList(): Promise<PublicDeal[]> {
  const res = await fetch(`${API_URL}/deals/page/list`);
  const json = await res.json();
  if (!json.success) throw new Error(json.message || 'Failed to load deals');
  return json.data;
}

export async function fetchDealBySlug(slug: string): Promise<PublicDeal> {
  const res = await fetch(`${API_URL}/deals/${encodeURIComponent(slug)}`);
  const json = await res.json();
  if (!json.success) throw new Error(json.message || 'Deal not found');
  return json.data;
}
